import React, { useState } from "react";
import Modal from "../../../../../parts/modal-new";
import submit from "submit-form";
import SvgIcon from "../../../../../parts/SvgIcon";

const DataSourceModal = ({ locals }) => {
  const { activeUserToRequest } = locals;
  const { mealPlanDataSources = ["usda", "nuttab"], _id: userId } =
    activeUserToRequest;
  const fixedSources = [
    { name: "Custom Foods", description: "Custom foods created by you" },
    {
      name: "Recipes",
      description: "Custom recipes created by you (see widgets)",
    },
  ];

  const selectableSources = [
    {
      name: "usda",
      description:
        "USA - FoodData Central (United States Department of Agriculture)",
    },
    {
      name: "nuttab",
      description: "AU - Nutrient Tables for Use in Australia",
    },
  ];

  const [selectedSources, setSelectedSources] = useState(mealPlanDataSources);

  /**
   * Function to select the options
   * @param {*} name
   */
  const handleSelectionChange = (name) => {
    setSelectedSources((prevSelected) =>
      prevSelected.includes(name)
        ? prevSelected.filter((source) => source !== name)
        : [...prevSelected, name]
    );
  };

  /**
   * Function to save the preference
   */
  const handleSend = () => {
    const body = {
      mealPlanDataSources: selectedSources,
      userId,
    };
    const stringBody = JSON.stringify(body); //we are doing this, becasue if we send an empty array we need to clean de property
    submit("/actions/user/edit-meal-plan-data-source-preference", {
      method: "POST",
      body: { stringBody },
    });
  };

  return (
    <Modal className="data-source-modal" title="Data Source">
      <div className="body">
        <div className="description">
          <span>
            Select the data sources you want to include in your search results
          </span>
        </div>
        <div className="selection">
          <ul>
            {/* First, the default ones */}
            {fixedSources.map(({ name, description }, index) => (
              <li key={`fixed-${name}-${index}`} className="not-eligible">
                <div className="information">
                  <span>{name}</span>
                  <span className="opacity-70">{description}</span>
                </div>
                <div className="checkbox">
                  <SvgIcon
                    src={`/img/new-icons/checked-square.svg`}
                    noFilterOnLight
                  />
                </div>
              </li>
            ))}

            {/* Then, the eligible */}
            {selectableSources.map(({ name, description }, index) => (
              <li key={`${name}-${index}`}>
                <div className="information">
                  <span>{name.toUpperCase()}</span>
                  <span className="opacity-70">{description}</span>
                </div>
                <div className="checkbox">
                  <SvgIcon
                    onClick={() => handleSelectionChange(name)}
                    src={`/img/new-icons/${
                      selectedSources.includes(name)
                        ? "checked-square.svg"
                        : "unchecked-square.svg"
                    }`}
                    noFilterOnLight={
                      selectedSources.includes(name) ? true : false
                    }
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer">
          <button data-button-type="primary" onClick={handleSend}>
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DataSourceModal;
